import React from 'react';

export default function Tire() {
  return (
    <svg
      width="36"
      height="87"
      viewBox="0 0 36 87"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.67815 0.71807V1.81475C8.67815 2.27874 9.04376 2.65488 9.49475 2.65488H10.3113C10.7623 2.65488 11.1279 2.27874 11.1279 1.81475V0.69511C11.4788 0.69458 11.8415 0.69458 12.2167 0.69458H16.5719V1.81475C16.5719 2.27874 16.9375 2.65488 17.3885 2.65488H18.2051C18.6561 2.65488 19.0217 2.27874 19.0217 1.81475V0.69458H23.6491C23.9281 0.69458 24.2002 0.69458 24.4657 0.694798V1.81475C24.4657 2.27874 24.8313 2.65488 25.2823 2.65488H26.0989C26.5499 2.65488 26.9155 2.27874 26.9155 1.81475V0.712492C30.459 0.777926 32.4949 1.08239 33.8719 2.49907C35.6258 4.30357 35.6258 7.20786 35.6258 13.0164V74.6257C35.6258 80.4343 35.6258 83.3386 33.8719 85.1431C32.4949 86.5598 30.459 86.8643 26.9155 86.9297V85.8274C26.9155 85.3634 26.5499 84.9873 26.0989 84.9873H25.2823C24.8313 84.9873 24.4657 85.3634 24.4657 85.8274V86.9474C24.2002 86.9476 23.9281 86.9476 23.6491 86.9476H19.0217V85.8274C19.0217 85.3634 18.6561 84.9873 18.2051 84.9873H17.3885C16.9375 84.9873 16.5719 85.3634 16.5719 85.8274V86.9476H12.2167C11.8415 86.9476 11.4787 86.9476 11.1279 86.9471V85.8274C11.1279 85.3634 10.7623 84.9873 10.3113 84.9873H9.49475C9.04376 84.9873 8.67815 85.3634 8.67815 85.8274V86.9241C5.30187 86.8477 3.3353 86.5231 1.99394 85.1431C0.23999 83.3386 0.23999 80.4343 0.23999 74.6257V13.0164C0.23999 7.20786 0.23999 4.30357 1.99394 2.49907C3.3353 1.11907 5.30187 0.794436 8.67815 0.71807Z"
        fill="#4F4F4F"
      />
      <rect
        x="5.76904"
        y="1.82947"
        width="24.3278"
        height="83.9832"
        fill="#4F4F4F"
      />
    </svg>
  );
}
